import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { AverageAvailability, HighAvailability, LowAvailability, NoAvailability, Wrapper, } from './styles';
function AvailabilityKey() {
    return (_jsxs(Wrapper, { children: [_jsx(HighAvailability, { children: "Good Availability" }), _jsx(AverageAvailability, { children: "Selling Fast!" }), _jsx(LowAvailability, { children: "Almost Gone" }), _jsx(NoAvailability, { children: "Sold Out" })] }));
}
export default AvailabilityKey;
